const cheetohPlayerSpritesheet = {
  "name": "cheetohPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/cheetohPlayerSpritesheet.png",
  "sprites": {
    "cheetohPlayerHead": [0],
    "cheetohPlayerBody": [1]
  }
}
export default cheetohPlayerSpritesheet;
